// base api url
export const config = {
  basePath: process.env.QC_API_URL || 'https://api.stag.quickcheckoutpage.com/v1',
  version: process.env.QC_UI_VERSION?.substr(0, 8) || 'local',
}
